import { apiClient } from '../lib/api/client';
import type { GenerateMessagePayload, GenerateMessageResponse } from '../models/message';

export const messageService = {
    list: async (): Promise<any[]> => {
        return apiClient.get<any[]>('/api/messages');
    },

    generateMessage: async (payload: GenerateMessagePayload): Promise<GenerateMessageResponse> => {
        return apiClient.post<GenerateMessageResponse>('/api/generate/message', payload);
    }
};
